// ABOUTME: Settings sidebar icon for application settings navigation
// ABOUTME: Shows gear/cog icon representing configuration options

import type { FC } from "react"

interface SettingsSidebarIconProps {
  className?: string
  size?: number
  color?: string
}

export const SettingsSidebarIcon: FC<SettingsSidebarIconProps> = ({ className, size = 20, color = "currentColor" }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_settings_sidebar)">
        <path
          d="M19 11V9C19 8.73478 18.8946 8.48043 18.7071 8.29289C18.5196 8.10536 18.2652 8 18 8H17.243L16.536 6.293L17.071 5.757C17.2585 5.56947 17.3638 5.31516 17.3638 5.05C17.3638 4.78484 17.2585 4.53053 17.071 4.343L15.657 2.929C15.4695 2.74153 15.2152 2.63621 14.95 2.63621C14.6848 2.63621 14.4305 2.74153 14.243 2.929L13.707 3.464L12 2.757V2C12 1.73478 11.8946 1.48043 11.7071 1.29289C11.5196 1.10536 11.2652 1 11 1H9C8.73478 1 8.48043 1.10536 8.29289 1.29289C8.10536 1.48043 8 1.73478 8 2V2.757L6.293 3.464L5.757 2.929C5.56947 2.74153 5.31516 2.63621 5.05 2.63621C4.78484 2.63621 4.53053 2.74153 4.343 2.929L2.929 4.343C2.74153 4.53053 2.63621 4.78484 2.63621 5.05C2.63621 5.31516 2.74153 5.56947 2.929 5.757L3.465 6.293L2.757 8H2C1.73478 8 1.48043 8.10536 1.29289 8.29289C1.10536 8.48043 1 8.73478 1 9V11C1 11.2652 1.10536 11.5196 1.29289 11.7071C1.48043 11.8946 1.73478 12 2 12H2.757L3.464 13.707L2.929 14.243C2.74153 14.4305 2.63621 14.6848 2.63621 14.95C2.63621 15.2152 2.74153 15.4695 2.929 15.657L4.343 17.071C4.53053 17.2585 4.78484 17.3638 5.05 17.3638C5.31516 17.3638 5.56947 17.2585 5.757 17.071L6.293 16.536L8 17.243V18C8 18.2652 8.10536 18.5196 8.29289 18.7071C8.48043 18.8946 8.73478 19 9 19H11C11.2652 19 11.5196 18.8946 11.7071 18.7071C11.8946 18.5196 12 18.2652 12 18V17.243L13.707 16.535L14.243 17.071C14.4305 17.2585 14.6848 17.3638 14.95 17.3638C15.2152 17.3638 15.4695 17.2585 15.657 17.071L17.071 15.657C17.2585 15.4695 17.3638 15.2152 17.3638 14.95C17.3638 14.6848 17.2585 14.4305 17.071 14.243L16.536 13.707L17.243 12H18C18.2652 12 18.5196 11.8946 18.7071 11.7071C18.8946 11.5196 19 11.2652 19 11Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 13C10.7956 13 11.5587 12.6839 12.1213 12.1213C12.6839 11.5587 13 10.7956 13 10C13 9.20435 12.6839 8.44129 12.1213 7.87868C11.5587 7.31607 10.7956 7 10 7C9.20435 7 8.44129 7.31607 7.87868 7.87868C7.31607 8.44129 7 9.20435 7 10C7 10.7956 7.31607 11.5587 7.87868 12.1213C8.44129 12.6839 9.20435 13 10 13Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_settings_sidebar">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
